export const objectTypes = ['consultation', 'patient', 'expertise', 'order'] as const

export type ObjectType = typeof objectTypes[number]

export type RecordingAnnotation = {
  id: string
  start: number
  end: number
  note: string
}

export type CreatePresignedUrlRequest = {
  fileName: string
  fileType: string
  objectType: ObjectType
  objectId: string
}

export type Document = {
  filename: string
  isRecording?: boolean
  key: string
  objectType: ObjectType
  recordingAnnotations?: RecordingAnnotation[]
  url: string
  uploadedBy?: string
}

export type DictaphoneDocument = Document & {
  text?: string
}
